// extracted by mini-css-extract-plugin
export default {"info":"PublicationsWarning__info-KAEsv"};